"use client";
import Link from 'next/link';
import { Button } from '@/components/ui/button';
import { useScrollAnimation } from '@/lib/useScrollAnimation';

export function CallToAction() {
  const { ref, isVisible } = useScrollAnimation();
  
  return (
    <section ref={ref as React.RefObject<HTMLElement>} className="section-padding">
      <div className="container">
        <div className={`rounded-2xl bg-gradient-to-br from-[color:var(--color-accent)] to-[color:var(--color-accent-hover)] p-8 md:p-12 shadow-xl ${isVisible ? 'animate-fade-in' : 'opacity-0'}`}>
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="text-center md:text-left">
              <h3 className="text-2xl md:text-3xl font-bold text-primary mb-3">
                Ready to Transform Your Space?
              </h3>
              <p className="text-base md:text-lg text-secondary max-w-2xl">
                Get expert plastering and drywall services. Schedule an inspection or request a free quote today.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 shrink-0">
              <Link href="/contact">
                <Button size="xl" variant="primary" className="shadow-lg whitespace-nowrap">
                  Get Free Quote
                </Button>
              </Link>
              <Link href="tel:3072773741">
                <Button size="xl" variant="secondary" className="shadow-lg whitespace-nowrap">
                  📞 Call Now
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
